// ante-react-kit/src/hooks/useIdleTimer.js
// Hook theo dõi trạng thái idle (không có thao tác từ người dùng), gọi callback onIdle khi vượt timeout.
import { useEffect, useRef, useCallback } from 'react';

const DEFAULT_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

export default function useIdleTimer({ timeoutMs, onIdle, enabled = true, events = DEFAULT_EVENTS }) {
    const timerRef = useRef(null);
    const enabledRef = useRef(enabled);

    useEffect(() => {
        enabledRef.current = enabled;
    }, [enabled]);

    const reset = useCallback(() => {
        if (timerRef.current) clearTimeout(timerRef.current);
        if (!enabledRef.current) return;
        timerRef.current = setTimeout(() => {
            if (enabledRef.current) onIdle();
        }, timeoutMs);
    }, [timeoutMs, onIdle]);

    useEffect(() => {
        if (!enabled) {
            if (timerRef.current) clearTimeout(timerRef.current);
            return;
        }
        reset();
        events.forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
            events.forEach((ev) => window.removeEventListener(ev, reset));
        };
    }, [enabled, reset, events]);

    return { reset };
}
